import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Procurement from "@/pages/Procurement";
import CargopticPricing from "@/pages/CargopticPricing";
import Bookings from "@/pages/Bookings";
import Shipments from "@/pages/Shipments";
import Detention from "@/pages/Detention";
import Invoices from "@/pages/Invoices";
import Carriers from "@/pages/Carriers";
import Consultant from "@/pages/Consultant";
import Rfq from "@/pages/Rfq";
import Documents from "@/pages/Documents";
import Settings from "@/pages/Settings";
import BillingSuccess from "@/pages/BillingSuccess";
import Admin from "@/pages/Admin";
import SailingSchedules from "@/pages/SailingSchedules";
import StakeholderNetwork from "@/pages/StakeholderNetwork";

const prot = (Page, adminOnly = false) => (
  <ProtectedRoute adminOnly={adminOnly}><Layout><Page /></Layout></ProtectedRoute>
);

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/billing/success" element={<BillingSuccess />} />
      <Route path="/dashboard" element={prot(Dashboard)} />
      <Route path="/procurement" element={prot(Procurement)} />
      <Route path="/pricing" element={prot(CargopticPricing)} />
      <Route path="/schedules" element={prot(SailingSchedules)} />
      <Route path="/network" element={prot(StakeholderNetwork)} />
      <Route path="/rfq" element={prot(Rfq)} />
      <Route path="/bookings" element={prot(Bookings)} />
      <Route path="/shipments" element={prot(Shipments)} />
      <Route path="/documents" element={prot(Documents)} />
      <Route path="/detention" element={prot(Detention)} />
      <Route path="/invoices" element={prot(Invoices)} />
      <Route path="/carriers" element={prot(Carriers)} />
      <Route path="/consultant" element={prot(Consultant)} />
      <Route path="/settings" element={prot(Settings)} />
      <Route path="/admin" element={prot(Admin, true)} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
